export { default as IgniteTestComponent } from "./components/ignite-test-component";



// WEBPACK FOOTER //
// ./src/index.js